export default "__VITE_ASSET__CXsNbA$l__"